import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_ACTIVE_ALARM_INSTANCE,
  API_PATH_ALARM_DEFINITION,
  API_PATH_ALARM_INTERCEPT,
  API_PATH_ALARM_NOTIFICATION_PROFILE,
  AlarmNotificationProfile,
  AlarmsDef,
  AlarmsInst,
  InterceptAlarm,
} from './alarmNotificationProfile.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getAlarmNotificationProfileList(
): AxiosPromise<ServerResponse<AlarmNotificationProfile>> {
  return http.get(`${API_PATH_ALARM_NOTIFICATION_PROFILE}`);
}

export function getInterceptAlarmList(
  requestParams?: string
): AxiosPromise<ServerResponse<InterceptAlarm>> {
  const url = requestParams? `${API_PATH_ALARM_INTERCEPT}?${requestParams}` : `${API_PATH_ALARM_INTERCEPT}`
  return http.get(url);
}

export function getAlarmsInstList(
  requestParams?: string
): AxiosPromise<ServerResponse<AlarmsInst>> {
  const url = requestParams? `${API_PATH_ACTIVE_ALARM_INSTANCE}?${requestParams}` : `${API_PATH_ACTIVE_ALARM_INSTANCE}`
  return http.get(url);
}

export function getAlarmsDefList(
): AxiosPromise<ServerResponse<AlarmsDef>> {
  return http.get(`${API_PATH_ALARM_DEFINITION}`);
}

export function getAlarmNotificationProfile(
  id: string,
): AxiosPromise<ServerResponse<AlarmNotificationProfile>> {
  return http.get(`${API_PATH_ALARM_NOTIFICATION_PROFILE}/${id}`);
}

export function createAlarmNotificationProfile(
  body: WithAuditDetails<AlarmNotificationProfile>,
): AxiosPromise<ServerResponse<AlarmNotificationProfile>> {
  return http.post(`${API_PATH_ALARM_NOTIFICATION_PROFILE}`, body);
}

export function updateAlarmNotificationProfile(
  id: string,
  body: WithAuditDetails<AlarmNotificationProfile>,
): AxiosPromise<ServerResponse<AlarmNotificationProfile>> {
  return http.put(`${API_PATH_ALARM_NOTIFICATION_PROFILE}/${id}`, body);
}

export function deleteAlarmNotificationProfile(
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<AlarmNotificationProfile>> {
  return http.delete(`${API_PATH_ALARM_NOTIFICATION_PROFILE}/${id}`, { data: body.auditDetails });
}
